<template>
  <div class="items" v-html="content.convictions"></div>
</template>

<script>
export default {
  name: 'ConvictionItem',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.items {
  padding: 0 0 16px 1rem;
}
</style>
